import React, { useEffect, useState } from 'react'
import { Row, Col, Tabs, Card, Button } from 'antd'
import Accounts from './components/Accounts'
import AccountStatement from './components/AccountStatement/accstatement2'

import { connect } from 'react-redux'

import "../Transfer/transfer.scss"
import './index.scss'
import { useHistory, useLocation } from "react-router-dom";
import { getPathnameByIndex } from "../../services/helper";
import GoBack from "components/goBack";
import { checkPermission } from "../../services/permission";
import { dateFormatter } from "../../services/helper";
import {
  ReloadIco
} from "../../../modules/CustomIcons";
import {getAccountStatementData, getAccountsData} from '../../store/actions/accountStatement';
import { useActions } from 'hooks/useActions';
import {getCurrentCompany} from '../../services/user';
import { useTranslation } from 'react-i18next'
import noSelected from "assets/images/noSelectedTransfer.svg";


const AccountPage: React.FC<any> = ({ leftMenuStatus, filterData, inProgressAccounts }) => {
  const {t} = useTranslation()
  // console.log(inProgressAccounts)
  const tabData: Array<any> = [
    {
      index: 1,
      name: t("home.accounts"),
      content: <Accounts />,
      path: '/accounts/accounts',
      permissionKey: 'CARILIST'
    },
    {
      index: 2,
      name: t("home.accountStatement"),
      content: <AccountStatement />,
      path: '/accounts/account_statement',
      permissionKey: 'ALL'
    },
  ]

  
  const { TabPane } = Tabs;
  const history = useHistory();
  const location = useLocation();
  const find_tab = tabData.find(row => row.path===`/${getPathnameByIndex(0)}/${getPathnameByIndex(1)}`);
  const [tabActiveKey, setTabActiveKey] = useState<number>(find_tab?.index);
  const [filterDateTime, setFilterDateTime] = useState(dateFormatter());
  
  const {getAccountStatementData, getAccountsData} = useActions();

  useEffect(() => {
    const find_tab = tabData.find(row => row.path===`/${getPathnameByIndex(0)}/${getPathnameByIndex(1)}`);

    setTabActiveKey(find_tab?.index);

  }, [location])

  const tabOnChange = (activeKey) => {
    setTabActiveKey(old_key => activeKey);

    const find_row = tabData.find(row => row.index == activeKey);

    history.push(find_row.path);
  };

  const refreshData = async () => {
    setFilterDateTime(old_date => dateFormatter());
    // if(tabActiveKey === 1) {
    //   await getAccountsData({ company: getCurrentCompany() })
    // }
    // else
      if(tabActiveKey === 2) {
      getAccountStatementData({ company: getCurrentCompany(), formData: filterData[0], paginationData: filterData[1] });
    }
  }


  return (
    <>
      <Row>
        <Col span={24} className="transfer account_statement-main">

          <Row justify='space-between'>
            <GoBack title={t("home.accounts")} />
            <Row className='account-refresh-date'>
              <Button icon={<ReloadIco />} onClick={refreshData} className='transparent box_reload_ico' />

              <span>{filterDateTime}</span>
            </Row>
          </Row>



          <Tabs
            type="card"
            className={tabActiveKey ? `account_statement-main transfer_parent_tab transfer_parent_tab_${tabActiveKey}` : `account_statement-main table-background transfer_parent_tab_${tabActiveKey}`}
            activeKey={`${tabActiveKey}`}
            onChange={tabOnChange}
            destroyInactiveTabPane={true}
          >


            {tabData &&
              tabData.map((item, index) => {
                return checkPermission(item.permissionKey) && (
                  <TabPane
                    className={`transfer_child_tabs account_child_tabs`}
                    tab={item.name}
                    key={item.index}
                  >
                    {getPathnameByIndex(1) && item.content}
                  </TabPane>
                )
              })}
          </Tabs>
        </Col>
        { tabActiveKey === undefined && <span className={'noSelected'}>{t("newTransfer.noSelectedTransfer")}
        <img src={noSelected}/>
              </span> }
      </Row>
    </>
  )
}


const mapDispatchToProps = { getAccountStatementData, getAccountsData }

const mapStateToProps = (state: any) => ({
  leftMenuStatus: state.home.leftMenuStatus,
  filterData: state.accountsStatement.filterData,
  inProgressAccounts: state.accountsStatement.inProgressAccounts,
})
export default connect(mapStateToProps, mapDispatchToProps)(AccountPage)
